import { IPostFormInitialState } from '../../components/Feed/reducer/reducer';
import { IContest, IProject, IThougth } from '../../types/global/helper';
import { LikeCategory, TLikeOrigin } from '../account/types';

export const types = {
    CREATE_THOUGTH: 'CREATE_THOUGTH',
    CREATE_THOUGTH_SUCCESS: 'CREATE_THOUGTH_SUCCESS',
    CREATE_THOUGTH_FAIL: 'CREATE_THOUGTH_FAIL',

    UPDATE_THOUGTH: 'UPDATE_THOUGTH',
    UPDATE_THOUGTH_SUCCESS: 'UPDATE_THOUGTH_SUCCESS',
    UPDATE_THOUGTH_FAIL: 'UPDATE_THOUGTH_FAIL',

    DELETE_THOUGTH: 'DELETE_THOUGTH',
    DELETE_THOUGTH_SUCCESS: 'DELETE_THOUGTH_SUCCESS',
    DELETE_THOUGTH_FAIL: 'DELETE_THOUGTH_FAIL',

    GET_THOUGTH: 'GET_THOUGTH',
    GET_THOUGTH_SUCCESS: 'GET_THOUGTH_SUCCESS',
    GET_THOUGTH_FAIL: 'GET_THOUGTH_FAIL',

    GET_ALL_THOUGTHS: 'GET_ALL_THOUGTHS',
    GET_ALL_THOUGTHS_SUCCESS: 'GET_ALL_THOUGTHS_SUCCESS',
    GET_ALL_THOUGTHS_FAIL: 'GET_ALL_THOUGTHS_FAIL',

    UPLOAD_THOUGTH_MEDIA: 'UPLOAD_THOUGTH_MEDIA',
    UPLOAD_THOUGTH_MEDIA_SUCCESS: 'UPLOAD_THOUGTH_MEDIA_SUCCESS',
    UPLOAD_THOUGTH_MEDIA_FAIL: 'UPLOAD_THOUGTH_MEDIA_FAIL',

    LIKE_A_THOUGTH: 'LIKE_A_THOUGTH',
    LIKE_A_THOUGTH_SUCCESS: 'LIKE_A_THOUGTH_SUCCESS',
    LIKE_A_THOUGTH_FAIL: 'LIKE_A_THOUGTH_FAIL',

    DELETE_A_THOUGTH_LIKE: 'DELETE_A_THOUGTH_LIKE',
    DELETE_A_THOUGTH_LIKE_SUCCESS: 'DELETE_A_THOUGTH_LIKE_SUCCESS',
    DELETE_A_THOUGTH_LIKE_FAIL: 'DELETE_A_THOUGTH_LIKE_FAIL',

    PUBLISH_THOUGTH: 'PUBLISH_THOUGTH',
    PUBLISH_THOUGTH_SUCCESS: 'PUBLISH_THOUGTH_SUCCESS',
    PUBLISH_THOUGTH_FAIL: 'PUBLISH_THOUGTH_FAIL',

    UNPUBLISH_THOUGTH: 'UNPUBLISH_THOUGTH',
    UNPUBLISH_THOUGTH_SUCCESS: 'UNPUBLISH_THOUGTH_SUCCESS',
    UNPUBLISH_THOUGTH_FAIL: 'UNPUBLISH_THOUGTH_FAIL',

    SET_UPLOAD_MEDIA: 'SET_UPLOAD_MEDIA',
    COMPLETE_MEDIA_UPLOAD: 'COMPLETE_MEDIA_UPLOAD',
};

export interface IThougthInitialState {
    thougthInCreation?: IThougth;
    selectedThougth?: IThougth;
    thougths?: IThougth[];
    creatingThougth?: boolean;
    gettingThougth?: boolean;
    thougthErrorMsg?: any;
    deletingThougth?: boolean;
    loading?: boolean;
    deletingLike?: boolean;
    userInteraction?: any;
    liking?: boolean;
}

export interface ICreateThougth extends Pick<IPostFormInitialState, 'publishStatus'> {
    thougth: string;
    images?: [File];
    videos?: [File];
    audios?: [File];
    files?: [File];
    scheduled_published_date?: string;
    is_background_color?: boolean;
    background_color?: string;
    font_family?: string;
    status?: string;
    hash_tags?: string[];
    mentions?: string[];
    isReplace?: boolean;
}

export interface IGetThougth {
    thougthId: string;
}

export interface IUploadThougthMedia {
    videos?: [File];
    audios?: [File];
    files?: [File];
    thougthId: string;
    images?: [File];
    videosKey?: string;
    isImage?: boolean;
}

export interface IUpdateThougth {
    thoughtId: string;
    body: {
        images?: [string];
        [key: string]: any;
    };
    fromUpload?: boolean;
    isLastItem?: boolean;
}

export interface ISetMediaUpload {
    category?: 'audios' | 'videos' | 'images' | 'files';
    keyFile?: string;
    thougth?: IThougth;
}

export interface ICompleteMediaUpload {
    category?: 'audios' | 'videos' | 'images' | 'files';
    thougthId?: string;
}

export interface IGetThougths {
    page?: number;
    limit?: number;
    field?: string;
}

export interface IReactToThougth {
    thoughtId: string;
    like_category: LikeCategory;
    like_type: 'like' | 'dislike';
    like_origin?: TLikeOrigin;
    /** For redirect */
    redirect?: string;
}

export interface IGenericLikeResponse {
    created_at: string;
    like_type: string;
    _id: string;
    user: string;
    created_by: string;
    project?: IProject;
    thougth?: IThougth;
    contest?: IContest;
    act?: IProject;
    like_category: LikeCategory;
    comment?: string;
    /** The below allows us to make real time interaction */
    optimistic?: boolean;
}

export interface ILikeThougthResponse {
    data: IGenericLikeResponse;
    like_origin?: TLikeOrigin;
    documentId?: string;
}
